import React from "react";
import images from "../../../images";

export default function QuestStatBox({
  icon,
  label,
  value,
  status = "default",
  isDisabled = false,
  isSlot = false,
}) {
  let bgColor = "bg-[#ECEEFF]";
  let textColor = "text-[#253FF6]";

  if (status === "rallycoins") {
    bgColor = "bg-[#ECEEFF]";
    textColor = "text-[#253FF6]";
  }

  if (status === "est") {
    bgColor = "bg-[#F4F2F2]";
    textColor = "text-[#333]";
  }

  if (status === "slotleft") {
    bgColor = "bg-[#F5E3E6]";
    textColor = "text-[#EF4056]";
    icon = images.User03Red;
  }

  if (status === "dailyQuotaLeft") {
    bgColor = "bg-[#F5E3E6]";
    textColor = "text-[#EF4056]";
    icon = images.DailyQuotaRed;
  }

  if (status === "highlight") {
    bgColor = "bg-[#F4F2F2]";
    textColor = "text-[#333]";
  } else if (status === "ineligible") {
    bgColor = "bg-[#E9E6E4]";
    textColor = "text-[#A0A0A0]";
  }

  if (isDisabled) {
    bgColor = "bg-[#E9E6E4]";
    textColor = "text-[#A0A0A0]";
  }

  return (
    <div
      className={`flex-1  h-auto flex flex-col justify-center items-center ${bgColor} rounded-md p-3 gap-[2px] text-center ${
        isDisabled ? "opacity-50 pointer-events-none" : ""
      }`}
    >
      <img src={icon} alt="" className="w-[15px] h-[15px]" />
      <p className={`${textColor} text-xs font-medium`}>{label}</p>
      <p className={`${textColor} text-xl font-bold`}>{value}</p>
    </div>
  );
}
